import { createAsyncThunk } from "@reduxjs/toolkit";
import { CoursesResponseModel, CoursesService } from "../../services/courses";
import { ErrorResponse } from "../../services/fetch-util";

export const Courses = createAsyncThunk<(ErrorResponse & CoursesResponseModel) | undefined, string | undefined, any>(
  "courses/get",
  async (url?: string) => (await CoursesService.getCourses(url || "")).parsedBody
);
